export default __webpack_public_path__ + "static/media/ICICI_Bank_Logo.3020875e.svg";